class TestimonialCarousel extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
    this.autoplayTimer = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.dotIndex, 10);
        this.setActive(idx);
        this.stopAutoplay();
      });
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.setActive(this.activeIndex - 1);
        this.stopAutoplay();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.setActive(this.activeIndex + 1);
        this.stopAutoplay();
      }
    });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = this.dataset.autoplay === 'true' && !prefersReducedMotion;
    const interval = parseInt(this.dataset.interval, 10) || 6000;

    if (autoplayEnabled) {
      this.startAutoplay(interval);
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay(interval));
      this.addEventListener('focusin', () => this.stopAutoplay());
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  setActive(index) {
    const total = this.slides.length;
    if (total === 0) return;

    const next = ((index % total) + total) % total;
    this.activeIndex = next;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === next);
    });
    this.dots.forEach((dot, i) => {
      const isActive = i === next;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  startAutoplay(interval) {
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => {
      this.setActive(this.activeIndex + 1);
    }, interval);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('testimonial-carousel')) {
  customElements.define('testimonial-carousel', TestimonialCarousel);
}
